import { ImagePreview } from '$comp/_app/components/chat/components/footer/components/send-field/components/upload-preview/image-preview'
import { nothing } from '$func/utils'

interface Props {
  file: File
  onCancel: any
  setFile: any
  onResetCb?: () => unknown
}

export function EditProfileDialog({
  onCancel,
  file,
  setFile,
  onResetCb,
}: Props) {
  return (
    <ImagePreview
      file={file}
      onCancel={onCancel}
      setFile={setFile}
      onResetCb={onResetCb}
      stencilType="CIRCULAR"
    />
  )
}

EditProfileDialog.defaultProps = {
  onResetCb: nothing,
}
